import {
    VALIDATE_ACCOUNT,
    VALIDATE_ACCOUNT_SUCCESS,
    VALIDATE_ACCOUNTS_FAILURE,
    RESET_VALIDATE_ACCOUNT,
} from '../actions';

const initialState = {
    validateAccount: {
        data: {},
        statusCode: '',
        statusMessage: '',
    },
    validateAccountLoading: false,
};

const validateAccountReducer = (state = initialState, action) => {
    switch (action.type) {
        case VALIDATE_ACCOUNT:
            return {
                ...state,
                validateAccountLoading: true,
            };
        case VALIDATE_ACCOUNT_SUCCESS:
            return {
                ...state,
                validateAccount: {
                    data: action.isCreditCardAccount,
                    statusCode: '10001',
                },
                validateAccountLoading: false,
            };
        case VALIDATE_ACCOUNTS_FAILURE:
            return {
                ...state,
                validateAccount: {
                    data: {},
                    message: action.stausMessage,
                    statusCode: '422',
                },
                validateAccountLoading: false,
            };
        case RESET_VALIDATE_ACCOUNT:
            return {
                ...initialState,
            };            
        default: {
            return { ...state };
        }
    }
};

export default validateAccountReducer;
